module.exports = __webpack_public_path__ + "img/reset.cd7f9791.svg";